export default function ComponentBlocksSingleVideo ({ Video }) {
  return (
    <div className="col-12">
      <video
        className="img-fluid w-100"
        width={Video.data.attributes.width}
        height={Video.data.attributes.height}
        controls
      >
        <source src={`${process.env.NEXT_PUBLIC_CMS_URL}${Video.data.attributes.url}`} />
      </video>
    </div>
  )
}
